<script lang="ts">
import { defineComponent, h } from 'vue';

import FadeTransition from '@/components/transitions/FadeTransition.vue';
import { StagesControllerData, stagesControllerKey } from '@/mixins/factory/stagesController';

export default defineComponent({
	inject: {
		stagesController: {
			from: stagesControllerKey,
			default: null,
		},
	},

	props: {
		amount: {
			type: Number,
			default: 1,
			validator: (value: number) => value > 0,
		},

		current: {
			type: Number,
			default: 1,
		},

		silent: {
			type: Boolean,
		},
	},

	computed: {
		controllerData(): StagesControllerData | null {
			return ((this as any).stagesController as StagesControllerData) ?? null;
		},

		silentTransition(): boolean {
			return this.controllerData?.silent ?? this.silent;
		},

		currentStage(): number {
			return this.controllerData?.currentStage ?? this.current;
		},

		stagesAmount(): number {
			return this.controllerData?.stagesAmount ?? this.amount;
		},
	},

	watch: {
		currentStage() {
			if (this.currentStage > this.stagesAmount || this.currentStage < 1) {
				console.error(
					`[BaseStages] Wrong 'current' prop value. Received: ${this.currentStage}, but the must >= 1 and <= ${this.amount}`,
				);
			}
		},
	},

	render() {
		const activeStageName = `stage-${this.currentStage}`;

		return h(
			FadeTransition,
			{ silent: this.silentTransition },
			{
				default: this.$slots[activeStageName],
			},
		);
	},
});
</script>
